import { useMemo } from "react";
import { getLocalMultiSelectState } from "../reducers/selectors";
import { useConfigurationRootState } from "./useConfigurationRootState";
export function useLocalMultiSelectState() {
    const ecsState = useConfigurationRootState();
    const multiSelectState = getLocalMultiSelectState(ecsState);
    return useMemo(() => {
        return multiSelectState;
    }, [multiSelectState]);
}
//# sourceMappingURL=useLocalMultiSelectState.js.map